var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 92.125,
    viewBox: "0 0 100 92.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002C5F;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10157",
    "data-name": "Path 10157",
    className: "cls-1",
    d: "M120.915,46.9a30.921,30.921,0,0,1-9.707,32.549,31.608,31.608,0,0,1-33.806,4.5L38.744,116.491,22.2,97.07,60.862,64.347a31.263,31.263,0,0,1,43.512-36.861L82.613,45.825l16.541,19.6Z",
    transform: "translate(-22.203 -24.367)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaller);
export default __webpack_public_path__ + "static/media/taller.26b764da6961a769ca1bb3a267f5a6ac.svg";
export { ForwardRef as ReactComponent };